<template>
  <DxPopup @hidden="onHidden" :visible="makePop" :show-close-button="true" :show-title="true" :title="'Information Request NDT (for Outfitting)'" height="900px" width="1600px" container=".v-application">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="'Information Request NDT'"
          :useBtnList="useBtnList"
          @btnRetrieve="btnRetrieve" @btnNdtRequest="btnNdtRequest" @btnClose="btnClose"
        >
          <template v-slot:body>
            <v-layout column >
              <v-row no-gutters>
                <v-col cols="12">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                  >
                    <template v-slot:body>
                      <v-row no-gutters class="center pa-0 pl-1">
                        <v-col cols="12">
                          <v-row dense>
                            <v-icon x-small color="blue" class="pt-1">mdi-circle</v-icon>
                            <span class="pa-2 pr-0 subText">Supplier name : </span>
                            <v-col cols="3">
                              <v-select
                                v-model="custCd"
                                :items="custCdList"
                                item-value="custCd"
                                item-text="supName"
                                return-object
                                single-line
                                outlined
                                dense
                                @change="doSearchList()"
                              ></v-select>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>

              <v-row dense style="background-color: #DFE3D5; border-top: 2px solid #214885; border-bottom: 2px solid #214885; border-right: 1px solid #bcc0c9; border-left: 1px solid #bcc0c9;">
                <v-row dense>
                  <v-col
                    v-for="n in 4"
                    :key="n"
                    style="border-right: 1px solid #bcc0c9"
                  >
                    <v-row no-gutters>
                      <v-col cols="5" align="right" class="pt-1 pr-2">
                        <span class="pa-2 pr-0 subText"> {{ selectMenu[n-1] }} </span>
                      </v-col>
                      <v-col cols="7">
                        <v-text-field 
                          v-if="n === 1"
                          v-model="shipNo" 
                          dense 
                          outlined 
                          hide-details="auto"
                          height="32"
                          maxlength="8"
                          readonly
                        />
                        <v-select
                          v-if="n === 2"
                          v-model="porNo"
                          :items="porNoList"
                          item-value="porNo"
                          item-text="porNo"
                          return-object
                          single-line
                          outlined
                          dense
                          @change="btnRetrieve()"
                        ></v-select>
                        <v-select
                          v-if="n === 3"
                          v-model="block"
                          :items="blockList"
                          item-value="block"
                          item-text="block"
                          return-object
                          single-line
                          outlined
                          dense
                          @change="btnRetrieve()"
                        ></v-select>
                        <v-select
                          v-if="n === 4"
                          v-model="inspLoc"
                          :items="inspLocList"
                          item-value="code"
                          item-text="codeName"
                          return-object
                          single-line
                          outlined
                          dense
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2" align="center" class="pt-2">
                    <span class="pa-2 pr-0 subText"> {{ selectMenu[4] }} </span>
                  </v-col>
                </v-row>
                <v-row dense class="pt-0 mt-0" style="border-top: 1px solid #bcc0c9">
                  <v-col
                    v-for="n in 4"
                    :key="n"
                    style="border-right: 1px solid #bcc0c9"
                  >
                    <v-row no-gutters>
                      <v-col cols="5" align="right" class="pt-1 pr-2">
                        <span class="pa-2 pr-0 subText"> {{ selectMenu2[n-1] }} </span>
                      </v-col>
                      <v-col cols="7">
                        <v-select
                          v-if="n !=2"
                          :disabled="n == 1 ? true : false"
                          v-model="models2[n-1]"
                          :items="items2[n-1]"
                          :item-value=" n === 3 ? 'codeName' : 'code' "
                          :item-text=" n === 3 ? 'timeNm' : 'codeName' "
                          return-object
                          single-line
                          outlined
                          dense
                          @change="n=='4' ? btnRetrieve() : ''"
                        ></v-select>
                        <DxDateBox
                          v-if="n ===2"
                          :value="insDate"
                          height="30px"
                          display-format="yyyy-MM-dd"
                          :acceptCustomValue="false"
                          @value-changed="e => {reqDtFrom = e.value && getStrFormat(e.value)}"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2" align="center" class="pt-1">
                    <v-select
                      v-model="empWelder"
                      :items="empWelderList"
                      item-value="empNo"
                      item-text="enm"
                      return-object
                      single-line
                      outlined
                      dense
                    ></v-select>
                  </v-col>
                </v-row>
              </v-row>

              <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="v80a1040Make"
                    :ref="v80a1040MakeRef"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="false"
                    :column-hiding-enabled="false"
                  >
                    <DxColumn data-field="no" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false" :visible="true" />
                    <DxColumn data-field="shipNo" caption="Ship No" width="10%" data-type="string" alignment="center" :allow-editing="false" :visible="true" />
                    <DxColumn data-field="block" caption="Block" width="10%" data-type="string" alignment="center" :allow-editing="false" :visible="true" />
                    <DxColumn data-field="itemDesc" caption="NDT Items" width="25%" data-type="string" alignment="center" :allow-editing="true" :visible="true" />
                    <DxColumn data-field="porNo" caption="POR No" width="10%" data-type="string" alignment="center" :allow-editing="false" :visible="true" />
                    <DxColumn data-field="partNo" caption="Part No" width="10%" data-type="string" alignment="center" :allow-editing="false" :visible="true" />
                    <DxColumn data-field="partSpec" caption="Matl Spec." width="25%" data-type="string" alignment="center" :allow-editing="true" :visible="true" />
                    <DxColumn data-field="unit" caption="Unit" width="5%" data-type="string" alignment="center" :allow-editing="false" :visible="true" />


                    <DxPaging :enabled="true" :page-size="17" />
                    <DxPager :visible="true"  :showInfo="false" />
                  </DxDataGrid>
                  <span style="font-weight: bold;">Count Total: {{ totalRow }} Row(s)</span>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';
import { DxDataGrid, DxEditing, DxColumn , DxPager ,DxLookup } from 'devextreme-vue/data-grid'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import { v80WeldEmp , addList , getPorNoList , getBlockList, getInsSeqNDT, v80a1080SaveNDT } from '@/api/view/hip/8/v80a1080Pop.js'
import { getDateFormat , getCurrentDate, lpad } from '@/utils/common.js'
import notify from 'devextreme/ui/notify' // message
import dayjs from 'dayjs'
import { getCmChildCode } from '@/api/system/cmCodeManage'

export default {
  name: 'v80a1080MPop',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxPopup,
    ICardVertical,
    iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPager,
    DxDateBox,
    DxLookup
  },
  props: {
    makePop: {
      type: Boolean,
      default() { return false }
    },
    makePopData: {
      type: Array,
      default() { return }
    },
    supNameList: {
      type: Array,
      default() { return }
    },
    shipNoListPop: {
      type: Array,
      default() { return }
    },
    insTimeListPop: {
      type: Array,
      default() { return }
    },
    ndtKindListPop: {
      type: Array,
      default() { return }
    },
    qmPartListPop: {
      type: Array,
      default() { return }
    },
    inspLocListPop: {
      type: Array,
      default() { return }
    },
    wkKindListPop: {
      type: Array,
      default() { return }
    },
  },
  data() {
    return {
      useBtnList: ['btnRetrieve' , 'btnNdtRequest' , 'btnClose'],
      v80a1040MakeRef: 'v80a1040MakeRef',
      gridMainList: [],
      totalRow: 0,

      selectMenu: ['ship No :' , 'Search POR :' , 'Search Block :' , 'Location :' , 'Welder member'],
      selectMenu2: ['QM Part :' , 'Insp. date :' , 'Insp. time :' , 'NDT Kind :' , 'Welder member'],

      // items:[this.shipNoListPop,this.porNoList,this.blockList,this.inspLocListPop],
      items2:[this.qmPartListPop,this.supNameList,this.insTimeListPop,this.ndtKindListPop],

      models:[],
      shipNo: '',
      por: '',
      block: '',
      inspLoc: '',
      wkKind: '',

      models2:[],
      qmPart: '',
      insDate: '',
      insTime: '',
      ndtKind: '',


      fileName: '',
      remark: '',

      custCd: '',
      custCdList: this.supNameList,
      shipNoList: this.shipNoListPop,
      kindCdList: this.inspectionList,
      insTimeList: [],

      kindInspList: this.kindInspListPop,
      empWelder: [],
      empWelderList: [],
      porNoList: [],
      porNo: '',
      blockList:[],
      inspLocList: this.inspLocListPop

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.v80a1040MakeRef)
    },
  },
  watch: {
    'makePop': {
      handler(value, oldValue) {
        if(value) {
          this.selectMenu = ['ship No :' , 'Search POR :' , 'Search Block :' , 'Location :' , 'Welder member']
          this.selectMenu2 = ['QM Part :' , 'Insp. date :' , 'Insp. time :' , 'NDT Kind :' , 'Welder member']
          this.items2 = [this.qmPartListPop,this.supNameList,this.insTimeListPop,this.ndtKindListPop]

          this.models = []
          this.shipNo =  ''
          this.por =  ''
          this.block =  ''
          this.inspLoc =  ''
          this.wkKind =  ''

          this.models2 = []
          this.qmPart =  ''
          this.insDate =  ''
          this.insTime =  ''
          this.ndtKind =  ''


          this.fileName =  ''
          this.remark =  ''

          this.custCd =  ''
          this.custCdList =  this.supNameList
          this.shipNoList =  this.shipNoListPop
          this.kindCdList =  this.inspectionList
          this.insTimeList =  []

          this.kindInspList =  this.kindInspListPop
          this.empWelder =  []
          this.empWelderList =  []
          this.porNoList =  []
          this.porNo =  ''
          this.blockList = []
          this.inspLocList =  this.inspLocListPop

          this.custCd = this.makePopData[0].supName
          this.qmPart = this.makePopData[0].qmPart
          this.ndtKind = this.makePopData[0].ndtKind
          this.shipNo = this.makePopData[0].shipNo
          this.insDate = this.makePopData[0].stDate
          this.wkKind = this.makePopData[0].wkKind

          this.models2 = [this.qmPart , this.insDate , this.insTime , this.ndtKind]
          this.doSearchList()
          this.doSearchMain()

        }
      },
      immediate: true
    }
  },
  mounted(){
    
    this.gridMainInstance.option('defaultPaging', false)
  },
  methods: {
    getStrFormat(date) {
      this.insDate = date
      return getDateFormat(date)
    },
    onHidden(e) {
      this.selectMenu = []
      this.models2 = []
      this.$emit('update:makePop', false)

    },
    isSave(saveData) {
      this.$emit('isSaved', saveData)
    },
    async doSearchList(){
      this.empWelderList = []
      this.porNoList = []
      let supNameGbn = this.custCd
      supNameGbn = supNameGbn.split(' : ')

      let params = {
        makerCd: supNameGbn[0],
        shipNo: this.shipNo
      }
      await v80WeldEmp(params).then(res => {
        if(res.list.length){
          this.empWelderList.push({ empNo: '' , enm: 'Select LQC..' })
          res.list.forEach(e => {
            this.empWelderList.push(e)
          });
          this.empWelder = this.empWelderList[0]
        }
      })
      await getPorNoList(params).then(res => {
        if(res.list.length){
          this.porNoList = res.list
        }
      })
      await getBlockList(params).then(res => {
        if(res.list.length){
          this.blockList = res.list
        }
      })
    },
    async doSearchMain(){
      this.gridMainList = []
      this.totalRow = 0

      let supNameGbn = this.custCd
      supNameGbn = supNameGbn.split(' : ')

      let params = {
        custCd: supNameGbn[0],
        shipNo: this.shipNo,
        qmPart: this.qmPart,
        block: !this.block.block ? '' : this.block.block ,
        ndtKind: this.models2[3].code,
        wkKind: this.wkKind.code,
        porNo: !this.porNo.porNo ? '' : this.porNo.porNo,

      }
      await addList(params).then(res => {
        if(res.list.length){
          let cnt = 1
          res.list.forEach(e => {
            e.id = cnt
            e.no = cnt++
            e.porNo = e.porNo + '-' + e.porSeq
          });
          this.gridMainList = res.list
          this.totalRow = res.list.length
        }
      })
    },
    btnRetrieve(e){
      if(!this.custCd){
        this.vToastify(this.$t('There is no Supplier to retrieve.'), 'warn')
        return
      }
      //shipNo
      if(!this.shipNo){
        this.vToastify(this.$t('There is no Supplier to retrieve.'), 'warn')
        return
      }
      this.doSearchMain()
    },
    async btnNdtRequest(){
      await this.gridMainInstance.saveEditData()
      var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()
      let minDate = new Date
      minDate.setDate(minDate.getDate() + 1);
      minDate = dayjs(minDate).format('YYYY-MM-DD')

      if(!selectedMainRows.length){
        this.vToastify(this.$t('Data is not selected!.'), 'warn')
        return
      }

      if(!this.empWelder){
        this.vToastify(this.$t('Please select Welder member!'), 'warn')
        return
      }
      /* if(!this.models[3]){
        this.vToastify(this.$t('Please select NDT check location!'), 'warn')
        return
      } */

      if(!this.inspLoc){
        this.vToastify(this.$t('Please select NDT check location!'), 'warn')
        return
      }

      let supNameGbn = this.custCd
      supNameGbn = supNameGbn.split(' : ')

      let param = {
        insDate: dayjs(this.insDate).format('YYYY-MM-DD'),
        shipNo: this.shipNo,
        makerCd: supNameGbn[0]
      } 
      let insSeq = 0

      getInsSeqNDT(param).then(res => {
        if(res.list.length){
          insSeq = Number(res.list[0].insSeq)
        }
      })

      for(var row of selectedMainRows){
        if(row.shipNo != this.shipNo){
          this.vToastify(this.$t('Ship No is different.'), 'warn')
          return
        }
        if(!this.insDate){
          this.vToastify(this.$t('Select Inspection Date.'), 'warn')
          return
        }
        //insTime
        if(!this.models2[2]){
          this.vToastify(this.$t('Select Inspection Time.'), 'warn')
          return
        }
        if(dayjs(this.insDate).format('YYYY-MM-DD') < minDate){
          this.vToastify(this.$t('You can not inspection request the inspection of this day. You select Inspection Date over today please!'), 'warn')
          return
        }
        row.insDate = dayjs(this.insDate).format('YYYY-MM-DD')
        row.insTime = this.models2[2].codeName
        row.custCd = supNameGbn[0]
        insSeq++
        row.insSeq  = lpad(insSeq, 3,'0')
        row.ndtKind = this.models2[3].code
        row.inspLoc = this.inspLoc.code
        // row.pipeDia = null
        // row.ndtNo   = null
        row.pipeDia = row.unit
        row.ndtNo   = row.partNo
        row.userId  = this.$store.state.user.userId
        row.empNo   = this.empWelder.empNo
        row.qmPart  = this.qmPart
        row.wkKind  = this.wkKind.code
        row.porNo   = this.porNo.porNo
      }
      
      try{
        this.openLoading('searching')
        // v80a1080SaveNDT2(selectedMainRows).then(res => {

        v80a1080SaveNDT(selectedMainRows).then(res => {
          if(res.body == 'Y'){
            notify(this.$t('Request Inspection saving is completed.'), 'success', 3000)
            let saveData = {
              inspDiv: this.makePopData[0].inspDiv,
              custCd: this.custCd,
              shipNo: this.shipNo,
              qmPart: this.models2[0],
              stDate: this.insDate,
              wkKind: this.wkKind,
              ndtKind: this.models2[3]
            }
            this.isSave(saveData)
          }else {
            this.vToastify(this.$t('An error has been occurred while saving data : ' + "<br>" + res.body), 'warn')
          }
        })
        .catch(error => {
          this.vToastify(error, 'warn')
          this.endLoading()
        })
        .finally(() => {
          this.gridMainInstance.clearSelection()
          this.doSearchMain()
        })
      } finally{
        this.endLoading()
      }

    },
    btnClose(){
      this.onHidden()
    },
    cellPrepared(e){
      if(e.rowType === 'data'){
        e.cellElement.style.padding = '0px'
      }
    },
    uppercase(){
      if(!this.block){
        this.block = this.block.toUpperCase()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.btn {
  background-color: rgb(135,155,119);
  margin-right: 2px;
  font-size: 10pt;
  color: white;
}
.btnClick{
  padding: 0;
  font-size: 12px;
}
.btnClick:hover{
  color: #4980BC;
}
.subText {
  font-size: 10pt;
  font-weight: bold;
  color: black;
}
</style>